import { GetOrderListResponse, GetPlayerListResponse } from '@/api/type/types';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface PlayerState {
  playerList: GetPlayerListResponse | null;
}

const initialState: PlayerState = {
  playerList: null,
};

export const playerSlice = createSlice({
  name: 'player',
  initialState,
  reducers: {
    setPlayerList: (state, action: PayloadAction<GetPlayerListResponse>) => {
      state.playerList = action.payload;
    },
  },
});

export const player = playerSlice.actions;
export default playerSlice.reducer;
